<template>
  <div>
        <loadingcomp mesaj="" v-model="loadingStatus"></loadingcomp>

    <v-dialog v-model="tahsilatdialog" persistent max-width="500px">
      <v-card color="grey lighten-5">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{dialogbaslik}} </v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <div class="flex md12">
            <v-layout row justify-center>
              <v-dialog v-model="alertshow" persistent max-width="290">
                <v-card>
                  <v-card-title class="headline">{{$t('Warning')}}</v-card-title>
                  <v-card-text>
                    Bakiyenizden ({{tahsilatbakiyem | moneyformat}}) büyük değer girmek üzeresiniz. 
                     <!--  {{ $t('You-cannot-enter-balance',{value: tahsilatbakiyem | moneyformat}) }} -->
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="alertshow = false">{{$t('Cancel')}}</v-btn>
                    <v-btn color="primary" flat @click="sendTahsilat()">{{$t('Continue')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
            <!-- <v-alert v-if="alertshow" v-model="alertmodel" type="error" class="mb-3">
              <span class="subheading">
                    {{ $t('You-cannot-enter-balance',{value: tahsilatbakiyem | moneyformat}) }}
              </span>
            </v-alert> -->
            <tarihcomp :etiket="$t('Payment-Date')" v-bind:defaultvalue="'ok'" v-model="val.Tarih"></tarihcomp>
            <v-layout>
              <v-autocomplete hide-details="" :items="itemsevraktipi" v-model="val.EvrakCinsi" clearable
                item-text="Title" item-value="Evrakkod" :label="$t('Document-Type')"></v-autocomplete>
              <v-text-field hide-details="" :label="$t('Document-No')" v-model="val.EvrakNo"></v-text-field>
            </v-layout>
            <v-text-field hide-details="" v-model="val.Aciklama" :label="$t('Description')"></v-text-field>
            <parainput :isPositive="true" :simge="getparabirimi()"  :etiket="this.$t('Amount')" v-model="val.Tutar" :autocomplete="'autocomplete'"></parainput>
            <v-layout>
              <v-select hide-details="" :items="doviztipi" @change="kurgetir(val.Tarih,val.Doviz)" v-model="val.Doviz"
                clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>
              <dovizinput :isPositive="true" :etiket="$t('Exchange-Rate')" v-model="val.Kur" :autocomplete="'autocomplete'"></dovizinput>
            </v-layout>
            <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" v-model="val.DovizTutar" @input="kurHesapla()" :autocomplete="'autocomplete'"></doviztutarcomp>
            <v-layout>
             
              <v-autocomplete :items="bankapositems" @change="taksitgetirtahsilat(val.PosKod)" hide-details=""
                v-model="val.PosKod" item-text="Title" item-value="PosKodu" clearable :label="$t('Pos-Code')"></v-autocomplete>
              
              <v-select :items="taksitsayitahsilat" @change="getTaksitLabel()"  hide-details="" v-model="val.TaksitKod" item-text="TaksitAciklama"
                item-value="TaksitID" clearable :label="$t('Instalment')"></v-select>

            </v-layout>

            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Score-Amount')" v-model="val.PuanTutar" :autocomplete="'autocomplete'"></parainput>
            
            <v-text-field hide-details="" :label="$t('Credit-Card-No')" v-model="val.KrediKartNo"></v-text-field>
           
            <v-select :items="itemsbanka" hide-details="" v-model="val.BankaKod" item-text="BankaAdi"
              item-value="BankaKod" clearable :label="$t('Bank-Code')"></v-select>

            <cariaracomp v-bind:etiket="$t('Select-Counter-Current')" v-bind:value="val.KarsiCari" :loading="loading" 
              v-model="val.KarsiCari" v-bind:statecariyedek="searchcaritahsilat"></cariaracomp>

          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-show="tahsilatguncellebuton === true">
            <v-btn id="bguncelle" color="blue darken-1" flat @click="tahsilatCheck(2)">{{ $t('Update') }}</v-btn>
          </div>
          <v-btn color="blue darken-1" flat @click.native="tahsilatdialog=false">{{$t('Cancel')}}</v-btn>
          <div v-show="kaydetbuton===true">
            <v-btn id="bkaydet" color="blue darken-1" flat @click="tahsilatCheck(1)">{{$t("save_button")}}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import parainput from '@/components/app/customcomp/parainput.vue'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import helpers from "@/components/app/customcomp/helpers.js"
  import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import loadingcomp from "@/components/app/customcomp/loadingcomp"

  export default {
    props: ["value"],
    components: {
      tarihcomp,
      parainput,
      dovizinput,
      doviztutarcomp,
      cariaracomp,
      loadingcomp
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      sendTahsilat(){
      this.alertshow = false;
        if(this.tahsilatDialogValue == 1){
          this.tahsilatkaydet();
        }else if(this.tahsilatDialogValue == 2){
          this.tahsilatguncelle();
        }
        this.tahsilatDialogValue = 0;
      },
      tahsilatCheck(val){
        // val = 1 kayt val = 2 guncelle  
      var sonbakiye = this.tahsilatbakiyem - this.val.Tutar
      if (sonbakiye > -1) {
        if(val == 1){
          this.tahsilatkaydet();
        }else if(val == 2){
          this.tahsilatguncelle();
        }
        
      }else{
        this.tahsilatDialogValue = val;
        this.alertshow = true;
      }
      },
      getTaksitLabel() {
        if (this.val.TaksitKod != undefined && this.val.TaksitKod != null  ) {
          this.taksitsayitahsilat.forEach(element => {
            if (element.TaksitID == this.val.TaksitKod) {
              this.val.TaksitKodLabel = element.TaksitAciklama
            }
          });
        } else {
          this.val.TaksitKodLabel = null
        }

      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      kurgetir(tarih, kod) {
        if(typeof kod === 'undefined'){
          this.val.Kur = 0;
          this.val.DovizTutar = 0;
          return false;
        }
        var params1 = {
          Tarih: tarih,
          DovizKod: kod
        }

        if (tarih != null && tarih != '') {

          this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
            headers: auth.getAuthCompaniesInfo()
          }).then((response) => {
            if(response.body == 0){
              this.val.Kur = 1;
            }else{
              this.val.Kur = response.body;
            }
            
            this.kurHesapla();
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-Kur Hesapla'
              this.snackbar = true
            }
          })
        }
      },
      kurHesapla(){
       this.kurinputaktif=true;
        if(this.val.Kur == 0){
          this.kurResult = this.val.DovizTutar
        }else{
          this.kurResult = this.val.Kur * this.val.DovizTutar
        }

        this.val.Tutar = this.kurResult

      },
      taksitgetirtahsilat(v) {
        this.bankapositems.forEach(element => {
          if (element.PosKodu == this.val.PosKod) {
            this.taksitsayitahsilat = []
            this.taksitsayitahsilat = element.Taksitler
          }
        });
      },
      open(title, bakiye) {
        
        if (title == 'tahsilat') {
          this.dialogbaslik = this.$t('Add-Collection')
          this.kaydetbuton = true
          this.tahsilatguncellebuton = false
          this.tahsilatbakiyem = bakiye;

        }


        if (title == 'update') {
          this.dialogbaslik = 'Tahsilat Güncelle'
          this.tahsilatguncellebuton = true
          this.kaydetbuton = false
          this.tahsilatbakiyem = bakiye + this.val.Tutar


          var seciliitems = [{
            autoText: this.val.KarsiCari + '-' + this.val.KarsiCari,
            unvan1: this.val.KarsiCari,
            id: this.val.KarsiCari
          }]
          this.statecaritahsilat = seciliitems
        }

        this.tahsilatdialog = true;

        this.taksitgetirtahsilat();
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
      tahsilatkaydet: tahsilatkaydet,
      tahsilatguncelle: tahsilatguncelle
    },
    data() {
      return {
        kurinputaktif:false,
        loadingStatus:false,
        kurResult:0,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tahsilatDialogValue:0,
      }
    },

    watch: {
      'val.Tutar' : function(val){

        if(this.val.Kur != 0 && !this.kurinputaktif){
          this.val.DovizTutar = val / this.val.Kur;
        }else{
          this.kurinputaktif=false;
        }
        
      },  
        bankapositems: function (val) {
        if (val.length > 0) {
          this.taksitgetirtahsilat();

        }
      },

    },
  }


  function tahsilatkaydet() {
  
      this.loadingStatus = true
     if (this.val.EvrakCinsi != null) {
      this.$emit('kurHesapla', this.kurResult)
      if(this.val.PosKod != null && this.val.TaksitKod == null){
          this.text1 = this.$t('cannot-leave-instalment-code-empty')
          this.snackbar = true
          this.loadingStatus = false;
      }
      else{
        let credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.alertshow = false
      var paramstahsilat = this.val
        if(paramstahsilat.Doviz == null){
          paramstahsilat.Doviz =  credentials.ParaBirimi;
          paramstahsilat.Kur = 1;
        }
      this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentAdd', paramstahsilat, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
          this.loadingStatus = false;

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

        if (response.body.Status == true) {
          this.tahsilatdialog = false
          this.resolve(true);
        }


      }, (response) => {
        if (response.status === 0) {
          this.resolve(false);
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.tahsilatdialog = false
        } else {
          this.resolve(false);
          this.text1 = response.body.StatusText
          this.snackbar = true
          this.tahsilatdialog = false
        }
      })
      }
        } else {
        this.text1 = this.$t('cannot-leave-document-type-empty')
        this.snackbar = true
        this.loadingStatus = false;
      }
    
  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bankapositems = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-bankpos'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-bankpos'
        this.snackbar = true
        this.progress = false
      }
    })


    this.$http.post(auth.API_URL + 'api/Bank/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsbanka = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      }
    })
    this.$http.post(auth.API_URL + 'api/doctype/List', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsevraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-doctype List'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-doctype List'
        this.snackbar = true
      }
    })



  }

  function tahsilatguncelle() {



      this.loadingStatus = true

      this.alertshow = false

      if (this.val.EvrakCinsi != null) {
      if(this.val.PosKod != null && this.val.TaksitKod == null){
          this.text1 = this.$t('cannot-leave-instalment-code-empty')
          this.snackbar = true
          this.loadingStatus = false
      }
      else{
        this.$emit('kurHesapla', this.kurResult)
        var paramstahsilat = this.val

        this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentUpdate', paramstahsilat, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          this.tahsilatdialog = false
          this.loadingStatus = false
          this.resolve(true);

        }, (response) => {
          if (response.status === 0) {
            this.resolve(false);

            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.tahsilatdialog = false

          } else {
            this.resolve(false);
            this.text1 = response.body.StatusText
            this.snackbar = true
            this.tahsilatdialog = false
          }
        })
      }
      } else {
        this.text1 = this.$t('cannot-leave-document-type-empty')
        this.snackbar = true
        this.loadingStatus = false
        this.tahsilatdialog = false
      }
   
  }
</script>